<template>
<div>  
<el-menu :default-active="activeIndex"   mode="horizontal" @select="handleSelect"   > 
  <el-menu-item index="0" style="margin-right:100px"> <img  src="/static/picture/10oa.png"></img> </el-menu-item>
  <el-menu-item index="1"> <span style="font-size:20px; " >首页</span> </el-menu-item>
  <el-menu-item index="2">  <span style="font-size:20px; " >功能 </span></el-menu-item>
  <el-menu-item index="3"> <span style="font-size:20px; " > 体验 </span></el-menu-item>
  <el-menu-item index="4"> <span style="font-size:20px; " > 价格 </span></el-menu-item>
  <el-menu-item index="9"> <span style="font-size:20px; " > 海关数据  </span> </el-menu-item>
  <el-menu-item index="6"> <span style="font-size:20px; " > 关于 </span></el-menu-item>

  
  <el-submenu v-if="login_state == 1" index="2" style="float: right;text-align: right;">
  
    <template slot="title">欢迎你, {{userInfo.phone}}</template>

    <el-menu-item index="2-1"> 账户设置 </el-menu-item>
    <el-menu-item index="2-2" > 退出登录  </el-menu-item> 
     
  </el-submenu> 
  <el-menu-item index="7" v-if="login_state == 0" style="margin-left:60px "> 登录 </el-menu-item> 
  <el-menu-item index="8" v-if="login_state == 0"  > 注册  </el-menu-item> 
</el-menu>
</div>
</template>
<script>
    export default {
        name: "appHeader",
        data () {
            return {
	    	activeIndex: '1',
		    userInfo: {},
			login_state : 0,
            text: "hallo,word",
            img: "",
            arr: [],
			} 
			 
        },
        methods: {
            click() {
                console.log(1111)
            },
			logout()
			{
			  console.log('out');
			  localStorage.setItem('userInfo',  '');
			  window.location.href= '/out';  
			},
			handleSelect(key, keyPath) {
              console.log(key, keyPath); 
			  if (key == 5)
			      return;
 
			  if (key == 1 || key == 0)
				  this.$router.push({
					name: 'index',
					params: {
					  sometext: ''
					}
				  });
			  if (key == 2)
				  this.$router.push({
					name: 'func',
					params: {
					  sometext: ''
					}
				  });			       
			  if (key == 3)
				  this.$router.push({
					name: 'demo',
					params: {
					  sometext: ''
					}
				  });	 
			  if (key == 4)
				  this.$router.push({
					name: 'price',
					params: {
					  sometext: ''
					}
				  });
			   
			  if (key == 6)
				  this.$router.push({
					name: 'about',
					params: {
					  sometext: ''
					}
				  }); 
		      
			  if (key == '2-1'){
				  this.$router.push({
					path: '/setting/myInfo',
					params: {
					  sometext: ''
					}
				  }); 
				  }
			  if (key == '2-2'){
                  localStorage.setItem('userInfo',  '');
				   
				  this.$router.push({
					path: '/home/index',
					params: {
					  sometext: ''
					}
				  });
				  location.reload();
				  }
              if (key == 7){
			       this.$router.push({
					name: 'login',
					params: {
					  sometext: ''
					}
				  });
				  /*
                   let newUrl = this.$router.resolve({
                     path: "/login"
                     });
                   window.open(newUrl.href, "_blank");	
                   */				   
                   }
			  if (key == 8){
			       this.$router.push({
					name: 'reg',
					params: {
					  sometext: ''
					}
				    });
				  }
			  if (key == 9){
			       this.$router.push({
					name: 'customsIndex',
					params: {
					  sometext: ''
					}
				    });
				  }
                    		   
             }
        },
        created() {
            let that = this;
		    var info1 = localStorage.getItem("userInfo"); 
            var userName = '';
            var userId = 0;
            var userPhone = '';
            var userEmail = '';
            if (info1 != undefined && info1 != '' && info1 != "undefined" && info1 != null){
              var info = JSON.parse(info1);
              that.userInfo = info ;   
			  that.login_state = 1;
			  console.log(that.userInfo);
			  }else
			  {
			  console.log(info1);
			  }

        }
    }
</script>

 

 



// WEBPACK FOOTER //
// src/components/appHeader.vue